export default {
  setAbout: (state, payload) => {
    state.about = payload;
  },
};
